// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"uQ-z","categoryName":"vQ-z","categoryNameSearchHeader":"wQ-z","categoryContent":"xQ-z","bottomAligned":"yQ-z","image":"zQ-z","imageNoBackground":"AQ-z"};